import React, { useState } from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import { uuid } from 'uuidv4';
import { AxiosInstance } from 'axios';
import { useModal } from '../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../FormComponent';
import { createSchemaByForm, IYup } from '../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../utils/getValidationErrors';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/Toast';
import { useSearch } from '../../../../hooks/Search';
import { urlWebsite } from '../../../../config';

interface ICreateModule {
  apiRef?: AxiosInstance;
  title: string;

  endpoint: string;

  buttonContent?: JSX.Element;
  addCallback?: Function;
  lineData: Record<string, any>;
}

export default function RedirectModule({
  apiRef = api,
  title,
  lineData,
  buttonContent = <span>Inscrever</span>,
}: ICreateModule): JSX.Element {
  const moduleCreate = (): JSX.Element => {
    return (
      <a target="_BLANK" href={`${urlWebsite}/nova-inscricao/${lineData.code}`}>
        {' '}
        <button type="button">{buttonContent}</button>
      </a>
    );
  };

  return moduleCreate();
}
